<template>
  <VTextField
    :id="id"
    ref="textField"
    v-model="value"
    :active="!!htmlValue"
    :label="label"
    :readonly="disabled"
    :bg-color="disabled ? 'disabled' : ''"
    :clearable="clearable && !disabled"
    :rules="rules"
    :type="type"
    :color="color"
    :hint="hint"
    :autofocus="autofocus"
    :placeholder="placeholder"
    :persistent-placeholder="persistentPlaceholder"
    :loading="loading"
  >
    <slot />

    <div v-if="htmlValue" v-html="htmlValue" />

    <template #clear>
      <VBtn
        v-if="clearable && !disabled"
        icon
        variant="text"
        size="x-small"
        :color="color ?? 'primary'"
        :tabindex="-1"
        @click="value = ''"
      >
        <VIcon size="x-large">$clear</VIcon>
      </VBtn>
    </template>

    <template #append v-if="$slots.append">
      <slot name="append" />
    </template>
    <template #append-inner>
      <slot name="append-inner" />
    </template>
  </VTextField>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "BTextField",

  props: {
    modelValue: { type: String as () => string | number | null, default: null },
    label: { type: String },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
    maxLength: { type: String },
    type: { type: String },
    id: { type: String },
    color: { type: String },
    hint: { type: String },
    placeholder: { type: String },
    autofocus: { type: Boolean },
    persistentPlaceholder: { type: Boolean },
    loading: { type: Boolean },
    rules: {
      type: Array as () => ((v: string) => string | true)[],
      default: () => [],
    },
    htmlValue: { type: String },
  },

  emits: ["update:modelValue", "click:clear"],

  computed: {
    value: {
      get() {
        return this.modelValue;
      },
      set(newValue: string | null) {
        this.$emit("update:modelValue", newValue);
      },
    },
  },

  methods: {
    async focus() {
      if (this.$refs.textField) {
        this.$nextTick(() => Object(this.$refs.textField).focus());
      }
    },
  },
});
</script>
